import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { efesBlue } from '../../../../theme';

const BulbIcon = ({ width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.187 25.188"
    fill={fill}
  >
    <path
      id="Path_2677"
      data-name="Path 2677"
      d="M8.937-18.687a4.88,4.88,0,0,0-4.875,4.875A.812.812,0,0,0,4.875-13a.812.812,0,0,0,.812-.812,3.254,3.254,0,0,1,3.25-3.25.812.812,0,0,0,.812-.812A.812.812,0,0,0,8.937-18.687ZM4.878.567a.807.807,0,0,0,.136.449L6.259,2.887a.813.813,0,0,0,.676.363h4a.812.812,0,0,0,.676-.363L12.86,1.016A.817.817,0,0,0,13,.567l0-2.193H4.876ZM8.937-22.75A8.906,8.906,0,0,0,0-13.812,8.888,8.888,0,0,0,2.212-7.933a14.532,14.532,0,0,1,2.662,4.68v0H7.311v-.006A2.4,2.4,0,0,0,7.2-3.971,16.013,16.013,0,0,0,4.045-9.54,6.48,6.48,0,0,1,2.44-13.812a6.473,6.473,0,0,1,6.5-6.5,6.507,6.507,0,0,1,6.5,6.5A6.48,6.48,0,0,1,13.83-9.54a16.049,16.049,0,0,0-3.153,5.559,2.891,2.891,0,0,0-.113.726v.005H13v0a14.52,14.52,0,0,1,2.662-4.68,8.892,8.892,0,0,0,2.212-5.88A8.938,8.938,0,0,0,8.937-22.75Z"
      transform="translate(0 22.75)"
      fill="#f4c430"
    />
  </svg>
);

BulbIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fill: PropTypes.string,
};

BulbIcon.defaultProps = {
  width: 25,
  height: 25,
  fill: efesBlue,
};

export default memo(BulbIcon);
